export const newTagLoginRequiredModal = (): HTMLElement | null =>
    (document.querySelector(".modal#add-bookmark-tag-login") as HTMLElement) || null
export const deleteBookmarkEntryModal = (): HTMLElement | null =>
    (document.querySelector(".modal#delete-bookmark-entry") as HTMLElement) || null
